export default __webpack_public_path__ + "static/media/LS-RTO.394e8422.svg";